<template>
  <v-layout row justify-center>
    <v-dialog persistent v-model="model">
      <v-card>
        <v-alert v-model="alert_flg" icon="warning" dismissible>9文字以内で入力してください。</v-alert>
        <v-card-title>{{mode==="axis"?"横":"縦"}}軸のラベルを入力</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-layout>
              <v-flex>
                <v-text-field
                  v-model="labelText"
                  label="ラベル名"
                  :counter="9"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row justify-center>
              <v-flex class="px-1">
                <v-btn
                  block
                  class="black--text"
                  color="primary"
                  @touchstart="onSetLabelBtnTouchStartHandler"
                  @mouseup="onSetLabelBtnTouchStartHandler"
                >
                  OK
                </v-btn>
              </v-flex>
              <v-flex class="px-1">
                <v-btn
                  block
                  flat
                  @touchstart="onClearLabelBtnTouchStartHandler"
                  @mouseup="onClearLabelBtnTouchStartHandler"
                >
                  削除
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "LabelDialog",

  data() {
    return {
      model: false,
      labelText: "",
      mode: "axis",
      alert_flg: false
    };
  },
  methods: {
    open(mode, text) {
      this.mode = mode;
      this.labelText = text;
      this.model = true;
      return true;
    },
    close() {
      this.model = false;
    },
    onSetLabelBtnTouchStartHandler(e) {
      this.alert_flg = false;
      const { mode } = this;
      if(this.labelText.length > 9) {
        this.alert_flg = true;
        return false;
      }
      this.$parent.setLabel({
        mode,
        text: this.labelText
      });
      this.close();
    },
    onClearLabelBtnTouchStartHandler(e) {
      const { mode, labelText } = this;
      this.$parent.clearLabel({ mode });
      this.close();
    }
  }
};
</script>